<template>
  <div :class="{ 'vue-bulma-tabs': true, [`is-layout-${layout}`]: true }">
    <div
      :class="{ tabs: true, [`is-${size}`]: size, [`is-${alignment}`]: alignment, [`is-${type}`]: type, 'is-fullwidth': isFullwidth }">
      <slot name="left-tab-list"></slot>
      <tab-list>
        <li v-for="(tab, index) in tabPanes"
            :key="index"
            role="tab"
            :class="{ 'is-active': isActive(index), 'is-disabled': tab.disabled, 'is-flex': true }"
            :aria-selected="isActive(index) ? 'true' : 'false'"
            :aria-expanded="isActive(index) ? 'true' : 'false'"
            :aria-disabled="tab.disabled ? 'true' : 'false'"
            :selected="isActive(index)"
            :disabled="tab.disabled"
            @click="select(index)">
          <a class="is-unselectable">
            <span :class="['icon', { 'is-small': size !== 'large' }]" v-if="tab.icon"><i :class="tab.icon"></i></span>
            <span v-translate>{{ tab.label }}</span>
          </a>
        </li>
      </tab-list>
      <slot name="right-tab-list"></slot>
    </div>
    <div class="tab-content is-flex">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import TabList from './TabList'

  export default {
    components: {
      TabList
    },
    props: {
      isFullwidth: Boolean,
      layout: {
        type: String,
        default: 'top',
        validator (val) {
          return ['top', 'bottom', 'left', 'right'].indexOf(val) > -1
        }
      },
      type: {
        type: String,
        default: ''
      },
      size: {
        type: String,
        default: ''
      },
      alignment: {
        type: String,
        default: ''
      },
      selectedIndex: {
        type: Number,
        default: -1
      },
      animation: {
        type: String,
        default: 'fade'
      },
      onlyFade: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        realSelectedIndex: this.selectedIndex,
        tabPanes: []
      }
    },
    mounted () {
      this.update()
      if (this.realSelectedIndex === -1) {
        this.select(0)
      }
    },
    methods: {
      update () {
        for (const tabPane of this.tabPanes) {
          if (!tabPane.disabled && tabPane.realSelected) {
            this.select(tabPane.index)
            break
          }
        }
      },
      isActive (index) {
        return index === this.realSelectedIndex
      },
      select (index) {
        this.$emit('tab-selected', index)
        this.realSelectedIndex = index
      }
    },
    watch: {
      selectedIndex (newIndex) {
        this.select(newIndex)
      }
    }
  }
</script>
